export const contactHeroText = {
  en: {
    line1: "Build a",
    line2: "Successful Business",
  },
  vi: {
    line1: "Xây dựng một",
    line2: "Doanh nghiệp thành công",
  },
};

// src/i18n/contactForm.js
export const contactFormText = {
  en: {
    title: "Get in Touch",
    office: "Head Office",
    sessionTitle: "Book Now",

    sessions: [
      {
        title: "Complimentary Business Growth Review",
        duration: "30 Minutes FREE",
        button: "Enquire Now",
        link: "email",
      },

      {
        title: "Business Strategy & Growth Planning Session",
        duration: "90 Minutes NZ$265",
        button: "Book Now",
        link: "https://www.paypal.com/ncp/payment/Q6T6NEXQMM2AJ",
      },

      {
        title: "Leadership & Management Development Session",
        duration: "120 Minutes NZ$385",
        button: "Book Now",
        link: "https://www.paypal.com/ncp/payment/CHZH6JXB4G32W",
      },
    ],
    call: "Call Now",
    book: "Send your Enquiry",
    contacting: "You are contacting us about:",
    formIntro:
      "Share your details and Maria will contact you to arrange a planning session for your business.",
    name: "Name *",
    tel: "Tel *",
    email: "Email *",
    company: "Company",
    subject: "Subject / Detail",
    timetable: "Preferred Timetable",
    timetablePlaceholder: "Example: Monday or Wednesday afternoon",
    submit: "Submit Request",
    workshop: "Workshop enquiry:",
  },

  vi: {
    title: "Liên hệ",
    office: "Trụ sở chính",
    sessionTitle: "Đặt Lịch",

    sessions: [
      {
        title: "Đánh Giá Tăng Trưởng Doanh Nghiệp",
        duration: "30 phút MIỄN PHÍ",
        button: "Liên hệ ngay",
        link: "/contact",
      },

      {
        title: "Tư Vấn Chiến Lược & Phát Triển Doanh Nghiệp",
        duration: "90 phút NZ$265",
        button: "Đặt Lịch",
        link: "https://www.paypal.com/ncp/payment/Q6T6NEXQMM2AJ",
      },

      {
        title: "Tư Vấn Phát Triển Lãnh Đạo & Quản Lý",
        duration: "120 phút NZ$385",
        button: "Đặt Lịch",
        link: "https://www.paypal.com/ncp/payment/CHZH6JXB4G32W",
      },
    ],
    call: "Gọi ngay",
    book: "Gửi yêu cầu",
    contacting: "Bạn đang liên hệ về:",
    formIntro:
      "Hãy để lại thông tin, Maria sẽ liên hệ với bạn để sắp xếp một buổi tư vấn cho doanh nghiệp của bạn.",
    name: "Họ tên *",
    tel: "Điện thoại *",
    email: "Email *",
    company: "Công ty",
    subject: "Nội dung",
    timetable: "Thời gian mong muốn",
    timetablePlaceholder: "Ví dụ: Thứ Hai hoặc chiều Thứ Tư",
    submit: "Gửi yêu cầu",
    workshop: "Quan tâm workshop:",
  },
};

// src/i18n/contactForm.js
export const AddressText = {
  en: {
    title: "Contact Info & Map",
    office: "Head Office",
    sessionTitle: "Book Your Session",

    contactCards: [
      {
        type: "office",
        title: "Head Office",
        value: "36 Princes Street, Onehunga, Auckland, New Zealand",
      },
      {
        type: "phone",
        title: "Phone",
        value: "+64 21 074 6258 | +61 41 059 6763 | WhatsApp • Viber • Zalo",
        value2: "",
      },
      {
        type: "email",
        title: "Email",
        value: "info@mariaadvisory.com",
      },
      {
        type: "hours",
        title: "Business Hours",
        value: "Mon–Fri: 9:00am – 6:00pm NZT",
        value2: "Sat: By appointment",
      },
    ],
  },

  vi: {
    title: "Liên hệ",
    office: "Trụ sở chính",
    sessionTitle: "Đặt Lịch Tư Vấn",

    contactCards: [
      {
        type: "office",
        title: "Trụ sở chính",
        value: "36 Princes Street, Onehunga, Auckland, New Zealand",
      },
      {
        type: "phone",
        title: "Điện thoại",
        value: "+64 21 074 6258 | +61 41 059 6763",
        value2: "WhatsApp • Viber • Zalo",
      },
      {
        type: "email",
        title: "Email",
        value: "info@mariaadvisory.com",
      },
      {
        type: "hours",
        title: "Giờ làm việc",
        value: "Thứ Hai–Thứ Sáu: 9:00 sáng – 6:00 chiều NZT",
        value2: "Thứ Bảy: Theo lịch hẹn",
      },
    ],
  },
};

export const TwoContactPathText = {
  en: {
    badge1: "PRIMARY ACTION",
    badge2: "SECONDARY ACTION",

    title1: "Book a Free Call",
    title2: "Send an Enquiry",

    rows: [
      {
        label: "Session",
        value: "Always FREE • 30 Minutes",
      },
      {
        label: "Format",
        value: "Phone • Video • In-person",
      },
      {
        label: "Purpose",
        value: "Discuss your business goals",
      },
      {
        label: "Commitment",
        value: "Zero obligation",
      },
    ],

    calendly:
      "Choose a convenient time and book directly into Maria's calendar.",

    ctaBook: "Book a Free Session",

    form: {
      name: "Full Name",
      email: "Email",
      phone: "Phone",
      message: "Message",

      namePlaceholder: "Your full name",
      emailPlaceholder: "your@email.com",
      phonePlaceholder: "(optional)",
      messagePlaceholder: "Tell us about your business...",

      button: "Send Message",
    },
  },

  vi: {
    badge1: "LỰA CHỌN ƯU TIÊN",
    badge2: "GỬI YÊU CẦU",

    title1: "Đặt Lịch Tư Vấn Miễn Phí",
    title2: "Gửi Yêu Cầu Tư Vấn",

    rows: [
      {
        label: "Buổi tư vấn",
        value: "Miễn phí • 30 phút",
      },
      {
        label: "Hình thức",
        value: "Điện thoại • Video • Trực tiếp",
      },
      {
        label: "Mục tiêu",
        value: "Trao đổi mục tiêu kinh doanh",
      },
      {
        label: "Cam kết",
        value: "Không ràng buộc",
      },
    ],

    calendly: "Chọn thời gian phù hợp và đặt lịch trực tiếp với Maria.",

    ctaBook: "Đặt Lịch Miễn Phí",

    form: {
      name: "Họ và tên",
      email: "Email",
      phone: "Điện thoại",
      message: "Nội dung",

      namePlaceholder: "Nhập họ và tên",
      emailPlaceholder: "email@cuaban.com",
      phonePlaceholder: "(không bắt buộc)",
      messagePlaceholder: "Cho Maria biết về nhu cầu của bạn...",

      button: "Gửi Yêu Cầu",
    },
  },
};

export const FullContactFormText = {
  en: {
    badge: "Maria Advisory",

    title: "Send Us A Message",

    subtitle:
      "Tell us about your business, goals or challenges and Maria will get back to you shortly.",

    fullName: "Full Name *",
    businessName: "Business Name",
    email: "Email Address *",
    phone: "Phone Number",

    service: "Interested In *",

    preferredTime: "Best Time To Contact",

    message: "Message *",

    messagePlaceholder:
      "Tell us about your business, goals, challenges or project...",

    privacy:
      "We respect your privacy. Your information will only be used to respond to your enquiry and will never be shared with third parties.",

    submit: "Send Message",
    sending: "Sending...",

    successTitle: "Thank You",
    successMessage:
      "Your enquiry has been successfully submitted. Maria Advisory will contact you within 24 business hours.",

    validation: {
      fullName: "Please enter your full name",
      email: "Please enter your email address",
      invalidEmail: "Please enter a valid email address",
      service: "Please select a service",
      message: "Please enter your message",
      summary: "Please complete the required fields.",
    },

    services: [
      "Business Coaching",
      "Business Consulting",
      "Investment Advisory",
      "Property Advisory",
      "Leadership Development",
      "Coach Training",
      "General Enquiry",
    ],

    contactTimes: ["Morning 9–12", "Afternoon 12–5", "Evening 5–8"],
  },

  vi: {
    badge: "Maria Advisory",

    title: "Gửi Yêu Cầu Tư Vấn",

    subtitle:
      "Hãy chia sẻ về doanh nghiệp, mục tiêu hoặc những khó khăn hiện tại và Maria sẽ liên hệ với bạn trong thời gian sớm nhất.",

    fullName: "Họ và Tên *",
    businessName: "Tên Doanh Nghiệp",
    email: "Email *",
    phone: "Số Điện Thoại",

    service: "Bạn Quan Tâm Đến *",

    preferredTime: "Thời Gian Liên Hệ Phù Hợp",

    message: "Nội Dung *",

    messagePlaceholder:
      "Hãy chia sẻ mục tiêu, kế hoạch hoặc những khó khăn hiện tại của bạn...",

    privacy:
      "Chúng tôi tôn trọng quyền riêng tư của bạn. Thông tin chỉ được sử dụng để phản hồi yêu cầu tư vấn và sẽ không được chia sẻ cho bên thứ ba.",

    submit: "Gửi Yêu Cầu",
    sending: "Đang gửi...",

    successTitle: "Cảm Ơn Bạn",
    successMessage:
      "Yêu cầu của bạn đã được gửi thành công. Maria Advisory sẽ liên hệ với bạn trong vòng 24 giờ làm việc.",

    validation: {
      fullName: "Vui lòng nhập họ tên",
      email: "Vui lòng nhập email",
      invalidEmail: "Email không hợp lệ",
      service: "Vui lòng chọn dịch vụ",
      message: "Vui lòng nhập nội dung",
      summary: "Vui lòng hoàn thiện các thông tin bắt buộc.",
    },

    services: [
      "Tư Vấn Kinh Doanh",
      "Chiến Lược Doanh Nghiệp",
      "Tư Vấn Đầu Tư",
      "Tư Vấn Bất Động Sản",
      "Phát Triển Lãnh Đạo",
      "Đào Tạo Coach",
      "Yêu Cầu Khác",
    ],

    contactTimes: ["Buổi sáng 9–12", "Buổi chiều 12–5", "Buổi tối 5–8"],
  },
};

export const contactText = {
  en: {
    title: "Let's Start the Conversation",
    subtitle: "Tell us about your goals and we will contact you shortly.",
    name: "Full Name *",
    business: "Business Name *",
    email: "Email *",
    phone: "Phone *",
    service: "How can we help you today?  *",
    time: "Best Time To Contact",
    message: "Message *",
    submit: "Send Message",
    sending: "Sending...",
    success: "Thank you. Your enquiry has been sent successfully.",
    services: [
      "Business Consulting Service",
      "Business Investment Advisory",
      "Property Investment Advisory",
      "Business Coaching & Training",
      "Leadership & Personal Development",
      "Become a Coach",
      "Complimentary 30-Minute Business Health Check",
      "Partnership Opportunities",
      "General Enquiry | Workshop | Webinar",
    ],
    times: ["Morning", "Afternoon", "Evening"],
    errors: {
      fullName: "Please enter your full name",
      business: "Please enter your business name",
      email: "Please enter your email",
      invalidEmail: "Please enter a valid email",
      time: "Please select a time",
      service: "Please select a service",
      message: "Please enter your message",
      phone: "Please enter your phone number",
    },
  },

  vi: {
    title: "Hãy Bắt Đầu Cuộc Trò Chuyện",
    subtitle:
      "Hãy chia sẻ mục tiêu của bạn và chúng tôi sẽ liên hệ với bạn trong thời gian sớm nhất.",
    name: "Họ và Tên *",
    business: "Tên Doanh Nghiệp *",
    email: "Email *",
    phone: "Số Điện Thoại *",
    service: "Chúng tôi có thể hỗ trợ bạn như thế nào? *",
    time: "Thời Gian Liên Hệ Phù Hợp",
    message: "Nội Dung *",
    submit: "Gửi Tin Nhắn",
    sending: "Đang gửi...",
    success: "Cảm ơn bạn. Yêu cầu của bạn đã được gửi thành công.",
    services: [
      "Tư vấn Doanh nghiệp",
      "Tư vấn Đầu tư Doanh nghiệp",
      "Tư vấn Đầu tư Bất động sản",
      "Huấn luyện & Đào tạo Doanh nghiệp",
      "Phát triển Lãnh đạo & Cá nhân",
      "Trở thành Huấn luyện viên",
      "Đánh giá Sức khỏe Doanh nghiệp Miễn phí trong 30 Phút",
      "Cơ hội Hợp tác",
      "Yêu cầu Chung | Hội thảo | Webinar",
    ],
    times: ["Buổi sáng", "Buổi chiều", "Buổi tối"],
    errors: {
      fullName: "Vui lòng nhập họ và tên",
      business: "Vui lòng nhập tên doanh nghiệp",
      email: "Vui lòng nhập email",
      invalidEmail: "Vui lòng nhập địa chỉ email hợp lệ",
      time: "Vui lòng chọn thời gian liên hệ",
      service: "Vui lòng chọn dịch vụ",
      message: "Vui lòng nhập nội dung",
      phone: "Vui lòng nhập số điện thoại",
    },
  },
};
